import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 语言
import i18n from './i18n/i18n'
// 全局资源
import noPic from '@/assets/no-pic.svg';

Vue.config.productionTip = false;
//引入echarts文件
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

// 注册全局属性
Vue.prototype.$noPic = noPic;

// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/rest/element-variables.css'
import ellocale from 'element-ui/lib/locale'
import el_zh from 'element-ui/lib/locale/lang/zh-CN'
ellocale.use(el_zh)
Vue.use(ElementUI,{ellocale});

// 全局事件
import utils from './utils/index'
Vue.use(utils)
//公共数据
import mix from './utils/mixins'
Vue.mixin(mix)
// 公共组件
import Header from './components/Header.vue'
Vue.component('Header',Header)
//konva
import VueKonva from 'vue-konva'
Vue.use(VueKonva)

// Axios
import requests from './api/index'
Vue.prototype.$axios = requests;

//自定义分享
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
